import React, { useState } from "react";
import { ACCENT } from "../artistStudio/shared";
import { discoveryApi } from "./discoveryApi";

// My Licences: the buyer's own switch for automatic renewal of a one-year licence. Turning it off is always possible; turning it on
// again works only while a card is saved for the licence (the server says so with can_auto_renew and answers 409 NO_SAVED_CARD).
export default function AutoRenewSwitch({ licence }) {
  const [on, setOn] = useState(Boolean(licence.auto_renew));
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const toggle = async () => {
    if (busy) return;
    const next = !on;
    setBusy(true);
    setError("");
    try {
      const r = await discoveryApi.setAutoRenew(licence.id, next);
      setOn(Boolean(r && r.auto_renew));
    } catch (e) {
      setError(e?.response?.data?.message || "We couldn't change this. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-1" data-testid="auto-renew">
      <button
        type="button" role="switch" aria-checked={on} onClick={toggle} disabled={busy}
        className="inline-flex items-center gap-2 text-xs font-semibold" style={{ color: on ? ACCENT : "#6b7280" }} data-testid="auto-renew-switch"
      >
        <span className="relative inline-block h-4 w-7 rounded-full" style={{ backgroundColor: on ? ACCENT : "#d1d5db" }} aria-hidden="true">
          <span className="absolute top-0.5 h-3 w-3 rounded-full bg-white transition-all" style={{ left: on ? "14px" : "2px" }} />
        </span>
        Renews automatically: {on ? "On" : "Off"}
      </button>
      {error && <p className="mt-1 text-xs text-red-700" role="alert" data-testid="auto-renew-error">{error}</p>}
    </div>
  );
}
